import { Alert, AlertDescription } from '@/components/ui/alert'
import type { FeedbackState } from './types'

interface TimelineFeedbackSnackbarProps {
  feedback: FeedbackState;
}

const TimelineFeedbackSnackbar: React.FC<TimelineFeedbackSnackbarProps> = ({ feedback }) => {
  if (!feedback.value) {
    return null;
  }
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 w-[min(480px,calc(100%-2rem))]">
      <Alert className="shadow-md" variant={feedback.value.severity === 'error' ? 'destructive' : 'default'}>
        <AlertDescription className="text-sm flex items-center justify-between">
          <span>{feedback.value.message}</span>
          <button
            onClick={feedback.clear}
            className="text-xs px-2 py-1 rounded border hover:bg-muted"
          >
            关闭
          </button>
        </AlertDescription>
      </Alert>
    </div>
  )
};

export default TimelineFeedbackSnackbar;
